// Labels for the past-research sources chip on an assistant chat message
// (`researchMeta`, written by chatWithChat / the communal drain). Pure, so it
// is unit-tested in tests/unit/researchSources.test.js.

const text = (v) => (typeof v === "string" && v.trim() ? v.trim() : "");

// "Title — Client, 2019", degrading gracefully when parts are missing and
// falling back to the id so a source is never rendered as an empty link.
export function sourceLabel(source) {
  if (!source || typeof source !== "object") return "";
  const title = text(source.title);
  const client = text(source.client);
  const year = Number.isInteger(source.year) ? String(source.year) : "";
  const tail = [client, year].filter(Boolean).join(", ");
  if (title && tail) return `${title} — ${tail}`;
  if (title) return title;
  if (tail) return tail;
  return text(source.id);
}

// Hover title for the chip: the first few source labels, then "+n".
export function researchChipTitle(meta, max = 5) {
  const sources = meta && Array.isArray(meta.sources) ? meta.sources : [];
  const labels = sources.map(sourceLabel).filter(Boolean);
  const head = labels.slice(0, max);
  const rest = labels.length - head.length;
  return head.join(" · ") + (rest > 0 ? ` · +${rest}` : "");
}
